const STORAGE_SUBSCRIBED = 'ancarta:popup:subscribed';
const STORAGE_DISMISSED_UNTIL = 'ancarta:popup:dismissed-until';
const SESSION_SHOWN = 'ancarta:popup:shown-session';

function shouldShow() {
  try {
    if (localStorage.getItem(STORAGE_SUBSCRIBED) === 'true') return false;
    const dismissedUntil = localStorage.getItem(STORAGE_DISMISSED_UNTIL);
    if (dismissedUntil && Date.now() < Number(dismissedUntil)) return false;
    // Already shown once this browsing session (this tab) — don't re-arm on
    // every page navigation just because the customer never formally
    // closed it (didn't click X / "No, thanks" / submit).
    if (sessionStorage.getItem(SESSION_SHOWN) === 'true') return false;
  } catch (error) {
    // Storage unavailable (private mode, etc.) — fail open and show the popup.
  }
  return true;
}

function markShownThisSession() {
  try {
    sessionStorage.setItem(SESSION_SHOWN, 'true');
  } catch (error) {
    // Ignore storage failures.
  }
}

function suppressFor(days) {
  try {
    const until = Date.now() + days * 24 * 60 * 60 * 1000;
    localStorage.setItem(STORAGE_DISMISSED_UNTIL, String(until));
  } catch (error) {
    // Ignore storage failures.
  }
}

function markSubscribed() {
  try {
    localStorage.setItem(STORAGE_SUBSCRIBED, 'true');
  } catch (error) {
    // Ignore storage failures.
  }
}

// The header's Shop All/Tops/Bottoms/Support triggers use aria-expanded as
// their single source of open/close state (see sections/ancarta-header.liquid) —
// setting it false here is the same thing their own click/outside-click/Escape
// handlers do, so this doesn't duplicate or fight that logic, just invokes it
// from one more place right before the popup takes over as the page's sole
// active layer.
function closeOpenNavMenus() {
  document.querySelectorAll('[data-ancarta-nav-trigger][aria-expanded="true"]').forEach((trigger) => {
    trigger.setAttribute('aria-expanded', 'false');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('ancarta-email-popup');
  if (!root) return;

  const dialog = root.querySelector('dialog');
  const suppressDays = Number(root.dataset.suppressDays) || 14;
  const delaySeconds = Number(root.dataset.delay) || 8;
  const openImmediately = root.dataset.openImmediately === 'true';

  const dismissButton = root.querySelector('[data-ancarta-popup-dismiss]');

  dismissButton?.addEventListener('click', () => {
    suppressFor(suppressDays);
    root.closeDialog?.();
  });

  dialog?.addEventListener('close', () => {
    suppressFor(suppressDays);
  });

  if (openImmediately) {
    // The customer form just posted successfully server-side (server-rendered success state) —
    // re-open the takeover immediately regardless of suppression so the shopper sees confirmation.
    markSubscribed();
    markShownThisSession();
    window.requestAnimationFrame(() => {
      closeOpenNavMenus();
      root.showDialog?.();
    });
    return;
  }

  if (!shouldShow()) return;
  if (window.location.pathname.startsWith('/account')) return;

  window.setTimeout(() => {
    if (!shouldShow()) return;
    markShownThisSession();
    closeOpenNavMenus();
    root.showDialog?.();
  }, delaySeconds * 1000);
});
